import { render, staticRenderFns } from "./GTopicForm.vue?vue&type=template&id=71185666&scoped=true&"
import script from "./GTopicForm.vue?vue&type=script&lang=ts&"
export * from "./GTopicForm.vue?vue&type=script&lang=ts&"
import style0 from "./GTopicForm.vue?vue&type=style&index=0&id=71185666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71185666",
  null
  
)

export default component.exports